import { Avatar } from '../../components/ui/bits';
import { cn } from '../../lib/cn';
import { signedPoints } from '../../lib/format';

export function Combatant({
  name,
  tone,
  score,
  you,
  initialsText,
  onClick
}: {
  name: string;
  tone: number;
  score: number;
  you?: boolean;
  initialsText: string;
  onClick?: () => void;
}) {
  const inner = (
    <>
      {you ? (
        <div className="grid h-[60px] w-[60px] place-items-center rounded-full border-2 border-white/20 bg-gradient-to-br from-night2 to-night text-[24px] font-extrabold text-white shadow-mark">
          {initialsText}
        </div>
      ) : (
        <Avatar name={name} tone={tone} size={60} className="border-2 border-white/20" />
      )}
      <div className="text-[13px] font-extrabold tracking-snug text-white">{you ? 'You' : name}</div>
      <div className={cn('num text-[30px] font-extrabold leading-none tracking-tight', you ? 'text-accent' : 'text-white')}>
        {signedPoints(score)}
      </div>
    </>
  );
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className="tap flex flex-1 flex-col items-center gap-2">
        {inner}
      </button>
    );
  }
  return <div className="flex flex-1 flex-col items-center gap-2">{inner}</div>;
}
